import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App';
import { guncellemeyiIzle } from './lib/guncelleme';

// Yeni sürüm devralınca sayfayı tazele — bkz. lib/guncelleme.ts
guncellemeyiIzle();

const el = document.getElementById('root');
if (!el) throw new Error('#root bulunamadı');

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
